module.exports = __webpack_public_path__ + "static/img/chat.7c81e864.png";